export default __webpack_public_path__ + "static/media/lesarcs-1x.96a9fc7f.webp";